import React, { useState, useEffect, useRef } from 'react';
import { Group } from '@mantine/core';

export default function StickyHeader({ children, ...props }) {
  const ref = useRef(null);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setStuck(!entry.isIntersecting),
      { threshold: 1, rootMargin: '-57px 0px 0px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={ref} style={{ height: 0 }} />
      <div
        style={{
          position: 'sticky',
          top: 56,
          zIndex: 20,
          backgroundColor: '#F6F5F4',
          paddingTop: 16,
          paddingBottom: 12,
          marginBottom: 4,
          marginTop: -16,
          marginLeft: -20,
          marginRight: -20,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <Group justify="space-between" {...props}>
          {children}
        </Group>
        {stuck && (
          <div
            style={{
              position: 'absolute',
              bottom: -12,
              left: 0,
              right: 0,
              height: 12,
              background: 'linear-gradient(to bottom, #F6F5F4, transparent)',
              pointerEvents: 'none',
            }}
          />
        )}
      </div>
    </>
  );
}
